import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import classes from './AllAnalytics.module.scss';
import cn from 'classnames';
import ShareTable from './components/ShareTable/ShareTable';
import AgreementChart from './components/AgreementChart/AgreementChart';
import SigningChart from './components/SigningChart/SigningChart';
import DocumentActivity from './components/DocumentActivity/DocumentActivity';
import UsersActivityTable from './components/UsersActivityTable/UsersActivityTable';
import MainInfo from './components/MainInfo/MainInfo';
import InivtesData from './components/InivtesData/InivtesData';
import { getPeriod, PeriodTypes } from 'helpers/getPeriod';

type AllAnalyticsProps = {
  choosenRoom: string;
  choosenPeriod: string;
  setChoosenPeriod: React.Dispatch<React.SetStateAction<string>>;
  availablePeriods: any[];
}

const AllAnalytics = ({ choosenRoom, choosenPeriod, setChoosenPeriod, availablePeriods}: AllAnalyticsProps) => {
  const [periodAsDates, setPeriodAsDates] = React.useState(getPeriod(choosenPeriod as PeriodTypes))
  const { t } = useTranslation();
  
  React.useEffect(() => {
    setPeriodAsDates(getPeriod(choosenPeriod as PeriodTypes));
  }, [choosenPeriod]);
  
  return (
    <div className={classes.contentWrap}>    
      <MainInfo
        period={periodAsDates}
        choosenRoom={choosenRoom !== 'all' ? choosenRoom : undefined}
      />
   
      <div className={classes.selectWrap}>
        <Select
          options={availablePeriods}
          popupMatchSelectWidth={false}
          value={choosenPeriod}
          onChange={setChoosenPeriod}
        />
      </div>

      <div className={classes.twoSections}>

        <InivtesData
          period={periodAsDates}
          choosenRoom={choosenRoom !== 'all' ? choosenRoom : undefined}
        />

        <div className={cn(classes.section, classes.share)}>
          <div className={classes.title}>{t('Analytics.section.sharing')}</div>
          <div className={classes.contenShare}>
            <ShareTable
              period={periodAsDates}
              choosenRoom={choosenRoom !== 'all' ? choosenRoom : undefined}
            />
          </div>
        </div>

      </div>

      <div className={classes.section}>
        <div className={classes.title}>{t('Analytics.section.processes')}</div>
        <div className={classes.contentProcesses}>
          <AgreementChart
            period={periodAsDates}
            choosenRoom={choosenRoom !== 'all' ? choosenRoom : undefined}
          />
          <SigningChart
            period={periodAsDates}
            choosenRoom={choosenRoom !== 'all' ? choosenRoom : undefined}
          />
        </div>
      </div>

      <div className={classes.section}>
        <div className={classes.docsActivity}>
          <DocumentActivity
            period={periodAsDates}
            choosenRoom={choosenRoom !== 'all' ? choosenRoom : undefined}
          />
        </div>
      </div>

      <div className={classes.section}>
        <div className={classes.title}>{t('Analytics.section.activity')}</div>
        <div className={classes.contentUserTable}>
          <UsersActivityTable
            period={periodAsDates}
            choosenRoom={choosenRoom !== 'all' ? choosenRoom : undefined}
          />
        </div>
      </div>

    </div>
  );
}

export default AllAnalytics;
